<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("shift", 2) }} {{ $t("close") }}
      </div>
      <div>
        <!-- <router-link class="btn-blue" to="edit-shift-close">
          <span>{{ $t('edit') }}</span>
        </router-link>-->
        <router-link class="btn-blue" to="shifts-close"
          >{{ $tc("shift", 2) }} {{ $t("close") }}
          {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div v-if="shiftCloseList.length > 0" class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("Operator") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ shiftCloseList[0]["operator"] }}
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("manager") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ shiftCloseList[0]["manager"] }}
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("shift", 1) }} {{ $tc("name") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ shiftCloseList[0]["shift_name"] }}
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("login_date_time") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ shiftCloseList[0]["login_date_time"] | fulldatemonparse }}
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("logout_date_time") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ shiftCloseList[0]["logout_date_time"] | fulldatemonparse }}
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ shiftCloseList[0]["modifiedAt"] | dateparse }}
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ shiftCloseList[0]["modifiedBy"] }}
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ shiftCloseList[0]["created_at"] | dateparse }}
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ shiftCloseList[0]["created_by"] }}
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3">
                <label>Payment Mode</label>
              </div>
              <div class="col-md-2">
                <label>No of Slips</label>
              </div>
              <div class="col-md-3">
                <label>Collection Amount</label>
              </div>
              <div class="col-md-2">
                <label>System Amount</label>
              </div>
              <div class="col-md-2">
                <label>Difference</label>
              </div>
            </div>
          </div>
          <div
            class="col-md-12 py-2 border-bottom"
            v-for="(ShiftCloseItem, ShiftCloseIndex) in shiftCloseList"
            :key="ShiftCloseIndex"
          >
            <div class="row">
              <div class="col-md-3">
                <label>{{ ShiftCloseItem.pm_payment_mode }}</label>
              </div>
              <div class="col-md-2">
                <label>{{ ShiftCloseItem.scs_no_of_slips }}</label>
              </div>
              <div class="col-md-3">
                <label>{{
                  currFormat(ShiftCloseItem.scs_user_recorded_amount)
                }}</label>
              </div>
              <div class="col-md-2">
                <label>{{
                  currFormat(ShiftCloseItem.scs_system_recorded_amount)
                }}</label>
              </div>
              <div class="col-md-2">
                <label>{{
                  currFormat(
                    ShiftCloseItem.scs_system_recorded_amount -
                      ShiftCloseItem.scs_user_recorded_amount
                  )
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3">
                <label>Total</label>
              </div>
              <div class="col-md-2">
                <label>{{
                  shiftCloseList.reduce(
                    (acc, { scs_no_of_slips }) =>
                      acc + parseInt(scs_no_of_slips),
                    0
                  )
                }}</label>
              </div>
              <div class="col-md-3">
                <label>{{
                  currFormat(
                    shiftCloseList.reduce(
                      (acc, { scs_user_recorded_amount }) =>
                        acc + scs_user_recorded_amount,
                      0
                    )
                  )
                }}</label>
              </div>
              <div class="col-md-2">
                <label>{{
                  currFormat(
                    shiftCloseList.reduce(
                      (acc, { scs_system_recorded_amount }) =>
                        acc + scs_system_recorded_amount,
                      0
                    )
                  )
                }}</label>
              </div>
              <div class="col-md-2">
                <label>{{
                  currFormat(
                    shiftCloseList.reduce(
                      (
                        acc,
                        { scs_user_recorded_amount, scs_system_recorded_amount }
                      ) =>
                        acc +
                        (scs_system_recorded_amount - scs_user_recorded_amount),
                      0
                    )
                  )
                }}</label>
              </div>
            </div>
          </div>

          <!-- <div class="col-md-12">
            <span>
              <div class="row border-bottom">
                <div class="col-lg-3">Float Amount</div>
                <div class="col-lg-9"></div>
              </div>
              <div class="row border-bottom pt-2">
                <div class="col-lg-3">Cash Collected</div>
                <div class="col-lg-9"></div>
              </div>
              <div class="row border-bottom pt-2">
                <div class="col-lg-3">Credit Card Payout</div>
                <div class="col-lg-9"></div>
              </div>
              <div class="row border-bottom pt-2">
                <div class="col-lg-3">Debit Card Payout</div>
                <div class="col-lg-9"></div>
              </div>
              <div class="row border-bottom pt-2">
                <div class="col-lg-3">Total</div>
                <div class="col-lg-9"></div>
              </div>
              <div class="row border-bottom pt-2">
                <div class="col-lg-3">Active</div>
                <div class="col-lg-9"></div>
              </div>
              <div class="row border-bottom pt-2">
                <div class="col-lg-3">Created By</div>
                <div class="col-lg-9"></div>
              </div>
              <div class="row border-bottom pt-2">
                <div class="col-lg-3"></div>
                <div class="col-lg-9"></div>
              </div>
              <div class="row border-bottom pt-2">
                <div class="col-lg-3">Modified By</div>
                <div class="col-lg-9"></div>
              </div>
              <div class="row border-bottom pt-2">
                <div class="col-lg-3">Modified At</div>
                <div class="col-lg-9"></div>
              </div>
            </span>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";

export default {
  name: "editShiftClose",
  data() {
    return {
      shiftCloseList: [],
      totalShiftClose: 0,
      paymentList: [],
      shiftClosePayload: {
        usl_id: null,
        user_shift_id: null,
        pos_user_id: null,
        login_date_time: null,
        logout_date_time: null
      }
    };
  },
  computed: {
    // ...mapGetters(["getUserShiftPaymentTypes"])
    getShiftClosePaymentTypes() {
      return this.paymentList;
    },
    shiftClosePaymentTotal() {
      return this.paymentList.reduce(
        (acc, { amount }) => acc + parseFloat(amount),
        0
      );
    }
  },
  beforeMount() {
    const { shift_id } = this.$route.query;

    if (shift_id) {
      // this.getPaymentTypes();
      this.getShiftCloseDetails(shift_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getShiftCloseDetails: function(shift_id) {
      MasterService.OnGetSingleViewShiftClose({ shift_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              console.log("data.Records :", data.Records);
              this.shiftCloseList = data.Records;
              // this.shiftClosePayload = {
              //   ...this.shiftClosePayload,
              //   ...data.Records[0],
              //   usl_id: data.Records[0].usl_id,
              //   user_shift_id: data.Records[0].user_shift_id,
              //   pos_user_id: data.Records[0].pos_user_id,
              //   login_date_time: data.Records[0].login_date_time,
              //   logout_date_time: data.Records[0].logout_date_time
              // };
            }
          } else {
            //
          }
        })
        .catch(this._CatchError);
    },
    oneditShiftClosePaymentHandler: function({ event, name, index, value }) {
      this.paymentList[index][name] =
        value && value.length > 0 && value.replace(/\s/g, "").length > 0
          ? parseFloat(value)
          : 0;
    },
    getPaymentTypes: function() {
      this.paymentList = [];
      let body = {
        tableName: "ms_payment_modes",
        pm_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              // this.paymentList =
              data.Records.map(x => {
                x["no_of_slips"] = 0;
                x["amount"] = 0;
                this.paymentList.push(x);
                return x;
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(this.AdminError);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ShiftCloseComponent/viewShiftClose.vue